import { useEffect } from 'react';
import { difference, pick, without } from 'lodash-es';
import { WithFilters } from '../../components/shared/SearchFilters';
import { RecoilState, SetterOrUpdater, useRecoilState } from 'recoil';

export function useSearchFilters<
  TFull extends WithFilters<unknown, TEnum[keyof TEnum]>,
  TEnum extends Record<string, string>,
  TFilters extends Record<keyof TEnum, string[]>
>(atom: RecoilState<TFull>, filters: TFilters, allowList: Array<keyof TFull>): [TFull, SetterOrUpdater<TFull>] {
  const [searchParams, setSearchParams] = useRecoilState(atom);

  useEffect(() => {
    const invalidFilters = difference(searchParams._filters, Object.keys(filters));
    const validParams = Object.values(filters).flat();

    // Check if there are invalid filters OR invalid top-level parameters
    const currentKeys = Object.keys(searchParams);
    const allowedKeys = [...validParams, 'limit', 'page', '_filters', ...(allowList as string[])];
    const invalidKeys = difference(currentKeys, allowedKeys);

    if (invalidFilters.length > 0 || invalidKeys.length > 0) {
      // Remove invalid parameters and invalid filters
      const cleanParams = pick(searchParams, allowedKeys);
      setSearchParams({
        ...cleanParams,
        _filters: without(searchParams._filters, ...invalidFilters)
      } as TFull);
    }
  }, [searchParams]);

  return [searchParams, setSearchParams];
}
